module.exports = __webpack_public_path__ + "static/img/icon_jiaoy.1570bd4b.png";